import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'

import './i18n'

import { store, persistor } from './store'
import reportWebVitals from './reportWebVitals'
import Spinner from './components/forms/Spinner/Spinner'
import SearchIndexingMeta from './components/SearchIndexing/SearchIndexingMeta'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <SearchIndexingMeta />
    <PersistGate loading={<Spinner open />} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
